import styled from 'styled-components';
import { tokens } from 'design-tokens/warwick/tokens';

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${tokens.semantic.color.background.welcomeScreen};
  position: relative;
  overflow: hidden;
`;

export const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 850px;
  padding: 40px;
`;

export const WelcomeModal = styled.div`
  background: ${tokens.semantic.color.background.welcomeModalOverlay};
  backdrop-filter: blur(20px);
  border-radius: ${tokens.primitive.radius[12]};
  padding: 50px 70px 45px;
  width: 100%;
  text-align: center;
  box-shadow: ${tokens.primitive.shadow.sm};
  border: 1px solid ${tokens.primitive.color.whiteAlpha10};
  transform: translateZ(0);
  will-change: auto;
`;

export const HotelBranding = styled.div`
  font-size: 13px;
  letter-spacing: 4.8px;
  color: ${tokens.primitive.color.gold};
  font-weight: ${tokens.primitive.typography.fontWeight.medium};
  margin-bottom: 28px;
  text-transform: uppercase;
  text-align: center;
  line-height: 24px;
`;

export const WelcomeHeading = styled.h1`
  font-size: 52px;
  font-weight: ${tokens.primitive.typography.fontWeight.regular};
  color: ${tokens.primitive.color.white};
  margin: 0 0 38px 0;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

export const GuestGreeting = styled.p`
  font-size: ${tokens.primitive.typography.fontSize[17]};
  color: ${tokens.primitive.color.white};
  margin: 0 0 22px 0;
  line-height: 1.7;
  text-align: left;
`;

export const GuestName = styled.span`
  color: ${tokens.primitive.color.gold};
  font-weight: ${tokens.primitive.typography.fontWeight.medium};
`;

export const WelcomeMessage = styled.div`
  font-size: ${tokens.primitive.typography.fontSize[14]};
  color: ${tokens.semantic.color.text.dialogBody};
  line-height: 1.75;
  margin: 0 0 28px 0;
  text-align: left;
  white-space: pre-line;
`;

export const SignatureSection = styled.div`
  text-align: left;
  margin: 35px 0 0;
  padding-left: ${tokens.primitive.space[16]};
  border-left: 3px solid ${tokens.semantic.color.border.managerSignature};
`;

export const SignatureTitle = styled.div`
  font-size: ${tokens.primitive.typography.fontSize[14]};
  color: ${tokens.primitive.color.whiteAlpha70};
  font-style: italic;
  margin-bottom: 2px;
`;

export const SignatureSubtitle = styled.div`
  font-size: ${tokens.primitive.typography.fontSize[14]};
  color: ${tokens.primitive.color.gold};
  font-weight: ${tokens.primitive.typography.fontWeight.medium};
`;

export const EnjoyButton = styled.button`
  background: ${tokens.semantic.color.button.backgroundPrimary};
  color: ${tokens.primitive.color.white};
  border: none;
  border-radius: ${tokens.primitive.radius[8]};
  padding: 14px 42px;
  font-size: ${tokens.primitive.typography.fontSize[17]};
  font-weight: ${tokens.primitive.typography.fontWeight.semiBold};
  cursor: pointer;
  margin: 42px auto 18px;
  display: block;
  transition: all 0.25s ease;
  transform: scale(1);
  box-shadow: ${tokens.primitive.shadow.sm};
  outline: none;
  letter-spacing: ${tokens.primitive.typography.letterSpacing.button};

  &:hover {
    filter: brightness(1.1);
    transform: scale(1.03);
  }

  &:focus,
  &:focus-visible {
    outline: none;
    filter: brightness(1.1);
    transform: scale(1.03);
    box-shadow: ${tokens.primitive.shadow.welcomeButtonFocus};
  }

  &:active {
    transform: scale(0.99);
  }
`;

export const FooterText = styled.p`
  font-size: 12px;
  color: ${tokens.primitive.color.whiteAlpha54};
  margin: 16px 0 0 0;
  font-weight: ${tokens.primitive.typography.fontWeight.regular};
  text-align: center;
`;
